import type { CamelCase } from "type-fest";

/**
 *
 *
 *
 *
 *
 */
export const random = (): number => Math.random();

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const isObject = <T extends object>(val: unknown): val is T =>
  typeof val === "object" && val !== null;

/**
 *
 *
 *
 *
 *
 *
 */
export const asObjectOrDefault = <T extends object>(val: unknown, defaultValue: T): T =>
  isObject(val) ? (val as T) : defaultValue;

export function camelcasify<Value extends string>(value: Value): CamelCase<Value> {
  const [[firstChar, ...firstRest], ...rest] = value.split(/[-_]/g);
  return firstChar
    .toLowerCase()
    .concat(
      ...firstRest,
      ...rest.flatMap(([firstCharOfRest, ...restOfTheRest]) => [
        firstCharOfRest.toUpperCase(),
        ...restOfTheRest,
      ]),
    ) as never;
}
